import { PropsWithChildren, useContext } from 'react';

import { TourContext } from './providers';
import { TourStep } from './TourStep';
import { TourStepProps } from './types';

type Props = PropsWithChildren<Partial<Omit<TourStepProps, 'step'>>> & {
  step: string;
};

export const GlobalTourStep = ({ step, children, ...tourProps }: Props) => {
  const ctx = useContext(TourContext);
  const type = ctx.type;
  const globalProps = ctx.globalStepProps?.[step];
  if (!globalProps || !type) {
    return <>{children}</>;
  }
  return (
    <TourStep
      {...tourProps}
      {...(globalProps as TourStepProps)}
      step={step}
      type={type}
    >
      {children}
    </TourStep>
  );
};
